import { render } from "./CreateTeamForm.vue?vue&type=template&id=29335fc9"
import script from "./CreateTeamForm.vue?vue&type=script&lang=js"
export * from "./CreateTeamForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__